import React, { FC } from 'react';

import {
  Box,
  Text,
  Flex,
  Modal,
  Button,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from '@chakra-ui/react';

import { useIsSuperAdmin } from 'store/slices';

import { Form, Formik } from 'formik';

import FormikInput from 'components/primitives/FormikInput';
import FormikSelectInput from 'components/primitives/FormikSelectInput';
import FormikSwitch from 'components/primitives/FormikSwitch';

import {
  rolesMap,
  getInitialValues,
  validationSchema,
} from './EditEmployeeModal.utils';

import { RolesEnum } from 'types/user';
import { EditEmployeeModalViewProps } from './EditEmployeeModal.props';

const labelProps = {
  fontSize: '12px',
  color: '#afafaf',
};

const normalRoles = [RolesEnum.WASH_HUB_STAFF, RolesEnum.WASH_HUB_ADMIN];
const allRoles = [
  RolesEnum.WASH_HUB_STAFF,
  RolesEnum.WASH_HUB_ADMIN,
  RolesEnum.SUPER_ADMIN,
];

const AddEmployeeModalView: FC<EditEmployeeModalViewProps> = (props) => {
  const isSuperAdmin = useIsSuperAdmin();

  const roles = isSuperAdmin ? allRoles : normalRoles;

  const { isOpen, onClose, onUpdate, isLoading, employee } = props;

  return (
    <Modal
      size="6xl"
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      scrollBehavior="inside">
      <ModalOverlay />
      <ModalContent borderRadius="30px">
        <ModalCloseButton _focus={{ outline: 'none' }} />
        <ModalHeader textAlign="center" fontWeight="500">
          edit employee - {employee?._id}
        </ModalHeader>
        <ModalBody>
          <Flex direction="column" p={6}>
            <Formik
              initialValues={getInitialValues(employee)}
              validationSchema={validationSchema}
              onSubmit={onUpdate}>
              {({ isValid, errors, values }) => {
                return (
                  <Form>
                    <Flex>
                      <FormikInput
                        name="fname"
                        label="First Name (*)"
                        labelProps={labelProps}
                        placeholder="Your text here"
                      />
                      <Box h="20px" w="50px" />
                      <FormikInput
                        name="lname"
                        label="Last Name (*)"
                        labelProps={labelProps}
                        placeholder="Your text here"
                      />
                    </Flex>
                    <Flex mt={4}>
                      <FormikSelectInput
                        label="Role (*)"
                        name="role"
                        placeholder="Select a role"
                        containerProps={{ flex: 1 }}>
                        {roles.map((r) => (
                          <option value={r} key={r}>
                            {rolesMap[r]}
                          </option>
                        ))}
                      </FormikSelectInput>
                      <Box h="20px" w="10px" />
                      <FormikInput
                        type="number"
                        name="phone"
                        label="Phone Number"
                        labelProps={labelProps}
                        placeholder="Your text here"
                        containerProps={{ flex: 1 }}
                      />
                    </Flex>
                    <Flex mt={4} maxW="390px">
                      <FormikInput
                        name="email"
                        label="Email (*)"
                        labelProps={labelProps}
                        placeholder="Your text here"
                      />
                    </Flex>
                    <Flex mt={4} alignItems="center">
                      <FormikSwitch name="isActive" />
                      <Text ml={2} {...labelProps} fontWeight="bold">
                        Active
                      </Text>
                    </Flex>
                    <Flex my={12} flexDirection="row" justifyContent="center">
                      <Button
                        variant="outline"
                        marginRight="10px"
                        isDisabled={isLoading}
                        w="134px"
                        onClick={onClose}>
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        isDisabled={!isValid || isLoading}
                        isLoading={isLoading}
                        w="134px">
                        Update
                      </Button>
                    </Flex>
                  </Form>
                );
              }}
            </Formik>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default AddEmployeeModalView;
